import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getDjangoEndpoint } from "src/utils/apiEndpoints";
import axiosInstance from "src/store/features/auth/axiosCSRF";


export interface iKinaseListState {
    response: any;
    isLoading: boolean;
    message: string;
}

const initialState: iKinaseListState = {
    response: [],
    isLoading: false,
    message: ""
};

export const getKinaseListAPI = createAsyncThunk(
    "GET_KINASE_LIST",
    async (_, { rejectWithValue }) => {
        try {
            const djangoEndpoint = getDjangoEndpoint();
            const pathParam = '/data/kinase-inhibitor/protein-name-list/';
        
            const response = await axiosInstance.get(`${djangoEndpoint}${pathParam}`, {
                withCredentials: true,
            });
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response ? error.response.data : error.message);
        }
    }
);
export const kinaseListSlice = createSlice({
    name: "kinaseList",
    initialState,
    reducers: {},
    extraReducers: (builder) => {   
        builder
            .addCase(getKinaseListAPI.pending, (state) => {
                state.isLoading = true;
                state.message = "";
            })
            .addCase(getKinaseListAPI.fulfilled, (state, action) => {
                state.response = action.payload;
                state.isLoading = false;
            })
            .addCase(getKinaseListAPI.rejected, (state) => {
                state.isLoading = false;
                state.message = "error";
            });
    }
});
export default kinaseListSlice.reducer;